/*! @azure/msal-react v2.0.22 2024-07-23 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "2.0.22";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
